export { default } from './PageDivider';
export type { Props, Props as PageDividerProps } from './PageDivider';
